import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

// API types
import type { LearnMoreResponseAdminDto } from '../../api/models';

@Component({
  selector: 'app-learn-more-item',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, CardModule],
  templateUrl: './learn-more-item.component.html',
  styleUrls: ['./learn-more-item.component.css'],
})
export class LearnMoreItemComponent {
  @Input({ required: true }) item!: LearnMoreResponseAdminDto;
  @Input({ required: true }) index!: number;
  @Input() coverImageUrl?: string; // Full URL for display
  @Output() edit = new EventEmitter<{ item: LearnMoreResponseAdminDto; index: number }>();
  @Output() remove = new EventEmitter<{ item: LearnMoreResponseAdminDto; index: number }>();

  onEdit(): void {
    this.edit.emit({ item: this.item, index: this.index });
  }

  onRemove(): void {
    this.remove.emit({ item: this.item, index: this.index });
  }
}
